import {Injectable} from '@angular/core';
import {KeycloakService} from "keycloak-angular";
import {jwtDecode} from "jwt-decode";
import {LoggedUser} from "../interfaces/logged-user";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
 private userId: string | null = null;
  constructor(private keycloakService: KeycloakService) { }

  async getToken(): Promise<string> {
   // console.log("Raw token: ", await this.keycloakService.getToken());
    return await this.keycloakService.getToken();
  }

  getTokenNoAsync(): Promise<string> {
    return this.keycloakService.getToken();
  }

  async getDecodedToken(): Promise<any> {
    const token = await this.getToken();
    return jwtDecode(token);
   
  }

  async getUserRoles(): Promise<string[]> {
    const decodedToken = await this.getDecodedToken();
    return decodedToken.realm_access.roles;
  }

  async getUserName(): Promise<string> {
    const decodedToken = await this.getDecodedToken();
    return decodedToken.preferred_username;
  }

  async logout(): Promise<void> {
    await this.keycloakService.logout();
  } 

  getLoggedUserLocalStorage(): LoggedUser | null{
    if (!localStorage.getItem('loggedUser')) {
      return null;
    }
    return JSON.parse(localStorage.getItem('loggedUser')!);
  }

  setLoggedUserOnLocalStorage(token: string){
    localStorage.setItem('loggedUser', JSON.stringify(jwtDecode(token)));
  }

  setUserId(id: string) {
    this.userId = id;
    localStorage.setItem('userId', id);
  }

  getUserId(): string | null {
    return this.userId || localStorage.getItem('userId');
  }

  async setUserIdFromToken(): Promise<void> {
    const token = await this.getToken();
    const decoded: any = jwtDecode(token);
    const id =decoded.preferred_username;//decoded.sub !!!! -replace with sub to separate environmentd in diff env-s;
    this.setUserId(id);
  }
}

